
/**
 * Index-classic-saas component
 */
import {
    MailIcon,
    UserIcon,
    KeyIcon,
    BookmarkIcon,
    UserCheckIcon,
    ArrowRightIcon
} from 'vue-feather-icons';
import Vue from 'vue';
import accountMenu from "@/views/account/menu.vue";
import infoService from "../../../services/infoService";
import { EventBus } from "../../../event-bus"

export default {
    data: () => ({
        info: {
            firstName: null,
            lastName: null,
            email: null,
            username: null,
            image: null,
        },
        overlay: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
        modalEditProfile: false,
        textResult: null,
        formChangePwdValid: false,
        newLogoImg: null,
        newLogoPreview: null,
    }),
    components: {
        UserIcon,
        UserCheckIcon,
        MailIcon,
        BookmarkIcon,
        KeyIcon,
        accountMenu,
        ArrowRightIcon
    },
    computed: {
        token() {
            return Vue.$cookies.get('user_token')
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        chooseFile() {
            this.$refs.newLogo.click()
        },
        uploadLogo() {
            if (this.newLogoImg != null) {
                let fd = new FormData();
                fd.append("fileupload", this.newLogoImg)

                this.overlay = true
                infoService.updateLogo(fd).then((resp) => {
                    if (resp.status == 200 && resp.data.status) {
                        this.cancelUpload();
                        this.getInfo()
                    } else {
                        this.$bvModal.msgBoxOk(
                            resp.data.message || "Can not update logo due to something went wrong.",
                            {
                                title: "Error",
                                centered: true,
                            }
                        )
                    }

                }).catch((err) => {
                    this.overlay = false
                    this.$bvModal.msgBoxOk(
                        "Can not update logo due to something went wrong.",
                        {
                            title: "Error",
                            centered: true,
                        }
                    )
                })
            }
        },
        cancelUpload() {
            this.newLogoImg = null
            this.newLogoPreview = null
        },
        onNewLogoChange(e) {
            if (e.target.files.length > 0) {
                this.newLogoImg = e.target.files[0]
                const reader = new FileReader();
                reader.onload = (event) => {
                    this.newLogoPreview = event.target.result;
                };
                reader.readAsDataURL(this.newLogoImg);
            } else {
                this.newLogoImg = null
                this.newLogoPreview = null
            }

        },
        openNewSite(newSite) {
            window.open(newSite, "_blank");
        },
        getInfo() {
            this.overlay = true
            infoService
                .getInfo()
                .then((resp) => {
                    if (resp.data.status == true && resp.data.result != null) {
                        let info = resp.data.result.info;

                        this.info.firstName = info.firstName;
                        this.info.lastName = info.lastName;
                        this.info.email = info.email;
                        this.info.username = info.username;
                        this.info.image = info.image || info.companies[0].coverImg;
                    } else {
                        throw "Can not get information user";
                    }
                })
                .catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.overlay = false
                });
        },
        editProfile() {
            this.overlay = true
            infoService
                .editProfile(this.info)
                .then((data) => {
                    // this.modalEditProfile = true
                    // this.textResult = "บันทึกสำเร็จ"
                    this.$bvModal.msgBoxOk('บันทึกสำเร็จ', {
                        title: "Status",
                        size: "sm",
                        okVariant: "success",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                })
                .catch((err) => {
                    // this.modalEditProfile = true
                    // this.textResult = "บันทึกไม่สำเร็จ"
                    this.$bvModal.msgBoxOk('บันทึกไม่สำเร็จ', {
                        title: "Status",
                        size: "sm",
                        okVariant: "danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    });
                    console.log(err);
                }).finally(() => {
                    this.overlay = false
                });
        },
        onChangePassword() {
            // check has new password
            if (this.newPassword != "" && this.newPassword != null) {
                if (this.oldPassword == "" || this.oldPassword == null) {
                    return this.$bvModal.msgBoxOk(
                        "Please specific old password.",
                        {
                            title: "Required Old Password",
                            centered: true,
                        }
                    )
                }

                if (this.newPassword != this.confirmPassword) {
                    return this.$bvModal.msgBoxOk(
                        "New password doesn't match with confirm password, please try again.",
                        {
                            title: "New Password Doesn't Match",
                            centered: true,
                        }
                    )
                }

                // call service
                this.overlay = true
                infoService.changePassword({
                    oldPwd: this.oldPassword,
                    newPwd: this.newPassword
                }).then((resp) => {
                    console.log(resp.data)
                    // alert
                    this.$bvModal.msgBoxOk(
                        "You have changed password, please login again.",
                        {
                            title: "Successfull",
                            centered: true,
                        }
                    ).then(() => {
                        // logout and force to login
                        EventBus.$emit("signOut");
                    })

                }).catch((err) => {
                    console.log(err)
                }).finally(() => {
                    this.overlay = false
                })
            } else {
                // do nothing
            }
        }
    },
};
